import reducer from "./entitiesReducers";

export default reducer;
